import React                      from 'react'
import { IObservableValue
       , observable }             from 'mobx'


export function filter_by_text ( text: string, filter_text: string )
{
  return new RegExp( filter_text, "i" ).test( text ) ;
}


export function Filter<T> ( name: string
                          , filter_fn: ( opts: any, value: T ) => boolean
                          , transform?: ( container: IObservableValue<T>, ev: any ) => any )
{
   const text        = observable.box<T>( )
      //  , def_filter  = ( opts: any, filter_text: string ) =>
      //    { 
      //      return !(text.get( ) as string).length
      //          || filter_by_text( opts[ name ], filter_text ) ;
      //    }
       , filter  = filter_fn ; // || def_filter ;

   return { get value ( ) { return text.get( ) }
          , pass_filter: ( opt: any ) => filter( opt, text.get( ) )
          , bind: 
            { get value ( ) { return text.get( ) }
            , onChange: transform? 
                        ( ev: any ) => transform( text, ev ) 
                      : ( ev: any ) => text.set( (ev as React.ChangeEvent<HTMLInputElement>).target.value as any )
            }
          } ;
}